import { render, staticRenderFns } from "./LocalDatabase.vue?vue&type=template&id=89c82f6c"
import script from "./LocalDatabase.vue?vue&type=script&lang=js"
export * from "./LocalDatabase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports